<template>
  <div id="chat" style="display: none"></div>
</template>
<script>
export default {
  created() {
    const genesysJsKey = '_genesysJs'
    const genesysKey = 'Genesys'

    window[genesysJsKey] = genesysKey
    window[genesysKey] = window[genesysKey] || {}
    const g = window[genesysKey]

    g.t = new Date().getDate()
    g.c = {
      environment: 'euc1',
      deploymentId: process.env.VUE_APP_CHAT_DEPLOYMENT_ID,
      debug: process.env.VUE_APP_CHAT_DEBUG
    }

    const script = document.createElement('script')
    script.src = 'https://apps.mypurecloud.de/genesys-bootstrap/genesys.min.js'
    script.async = true

    document.body.appendChild(script)

    script.onload = () =>
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        Genesys('subscribe', 'Messenger.opened', () => {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'uaevent',
            eventCategory: 'chat',
            eventAction: 'interactions chat',
            eventLabel: 'Ouverture du chat'
          })
        })
        // eslint-disable-next-line no-undef
        Genesys('subscribe', 'Conversations.started', () => {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'uaevent',
            eventCategory: 'chat',
            eventAction: 'interactions chat',
            eventLabel: 'Discussion commencée par le client'
          })
        })
      }, 1000)
  },
  methods: {}
}
</script>
